import {DomainAncestor, entityConfig} from "../../../core/common/domain/DomainAncestor";
import {observable} from "mobx";
import {ID} from "../../../core/metamodel/metaConstant";
import {ProjectVersion} from "./projectVersionDomain";
import {LovItem} from "../../../core/metamodel/mdEntity";

@entityConfig()
export class Project extends DomainAncestor {

  @observable projectId: number;
  @observable name: string;
  @observable description: string;
  @observable address : string;
  @observable cadastralParcelNumber: string;
  @observable documentationCreator: string;
  @observable documentationCreated: Date;
  @observable documentationLevel: LovItem<DOCUMENTATIONLEVEL>;
  @observable evaluator: string;
  @observable projectCreated: string;
  @observable certified_person: string;

  @observable area : number;
  @observable countOfHousingUnits: number;
  @observable countOfPeople: number;
  @observable buildingType: LovItem<BUILDINGTYPE>;
  @observable schoolLevel: LovItem<SCHOOLLEVEL>;
  @observable cellarCompartment: boolean;
  @observable garage: boolean;
  @observable zpkm: boolean;

  @observable projectVersions : ProjectVersion[];
  @observable cadastralParcelArea : string;
  @observable documentationVersion : string;
  @observable projectEvaluationFinished : Date;
  @observable estimatedCosts : string;
  @observable anticipatedCommissioning : Date;
  @observable evaluationPhase : LovItem<EVALUATIONPHASE>;
  @observable evaluationType : LovItem<EVALUATIONTYPE>;


  constructor(json: any) {
    super(json);
  }

  public getId(): ID {
    return this.projectId;
  }

  public setId(id: ID): void {
    this.projectId = <number>id;
  }
}

export enum DOCUMENTATIONLEVEL {
  STS="STS",
  DUR="DUR",
  DSP="DSP",
  DOS="DOS",
  DZS="DZS",
  DPS="DPS",
  RDS="RDS",
  DSPS="DSPS"
}

export enum BUILDINGTYPE {
  BD = 1,
  RD = 2,
  EDU = 3,
  AB = 4,
  UNI = 5
}

export enum SCHOOLLEVEL {
  FIRST="FIRST",
  SECOND="SECOND",
  THIRD="THIRD"
}

export enum EVALUATIONPHASE {
  EVALUATION_QUALITY_DESIGN="hodnocení kvality návrhu budovy (projekt)",
  EVALUATION_QUALITY="hodnocení kvality budovy (dokončená stavba po kolaudaci)"
}
export enum EVALUATIONTYPE {
  NEW_CONSTRUCTION_RECONSTRUCTION="novostavba vs. rekonstrukce",
  SHELL_AND_CORE="shell and core (pro novostavbu i pro rekonstrukci)"
}




// WEBPACK FOOTER //
// ./src/sbtool/domain/project/projectDomain.ts